import { isBlank, parseString, formatNumber } from '../../commons.js';
import BaseController from './base.js';

export default class extends BaseController {

  select_nature(e) {
    var form = e.target.closest('form')
    var amount = e.target.options[e.target.selectedIndex].dataset.amount;
    if (!isBlank(amount)) {
      form.querySelector("#charge_default_amount").value = amount
    } else {
      form.querySelector("#charge_default_amount").value = 0
    }
    this.recompute_charge(e)
  }

  recompute_charge(e) {
    var form = e.target.closest('form')
    let base_amount = parseString(form.querySelector('[name="charge[default_amount]"]').value)
    let how_many = parseString(form.querySelector('[name="charge[how_many]"]').value)
    form.querySelector('[name="charge[amount]"]').value = formatNumber(base_amount * how_many)
  }

}
